"use strict";
import { CurrencyAmount } from "@uniswap/sdk-core";
import { Pool as V4Pool } from "@uniswap/v4-sdk";
export function amountWithPathCurrency(amount, pool) {
  return CurrencyAmount.fromFractionalAmount(
    getPathCurrency(amount.currency, pool),
    amount.numerator,
    amount.denominator
  );
}
export function getPathCurrency(currency, pool) {
  if (pool.involvesToken(currency)) {
    return currency;
  } else if (pool.involvesToken(currency.wrapped)) {
    return currency.wrapped;
  } else if (pool instanceof V4Pool) {
    if (pool.token0.wrapped.equals(currency)) {
      return pool.token0;
    } else if (pool.token1.wrapped.equals(currency)) {
      return pool.token1;
    }
  } else {
    throw new Error(`Expected currency ${currency.symbol} to be either ${pool.token0.symbol} or ${pool.token1.symbol}`);
  }
  return currency;
}
